import Moment from 'moment';
import { VatTariffs, VatService } from '../VatService';
import Resource from './Resource';

export { VatTariffs, VatService };

/**
 * Expense Resource
 */
class Expense extends Resource
{
    constructor() {
        super('accounting.expense', ['expenses']);
    }

    search(query, params = {}, config = {}) {
      params = Object.assign(params, { query });

      return this._doGet(['search'], params, config);
    }

    writeOffItem(expense_id, item_id, quantity) {
        return this._doPut([expense_id, 'items', item_id, 'write-off'], {quantity})
    }

    tag(id, tag_name) {
        return this._doPost([id, 'tags'], { tag_name })
    }

    untag(id, tag_id) {
        return this._doDelete([id, 'tags', tag_id])
    }

    options() {
        return this._doGet(['options']);
    }
}   

export let ExpenseResource = new Expense();

/**
 * ExpenseItem Resource
 */
class ExpenseItem extends Resource
{
    constructor() {
        super('accounting.expense.item', ['expenses/items']);
    }

    options() {
        return this._doGet(['options']);
    }
}   

export let ExpenseItemResource = new ExpenseItem();


/**
 * Expense Category Resource
 */
class ExpenseCategory extends Resource
{
    constructor() {
        super('accounting.expense.category', ['expenses', 'categories']);
    }
}   

export let ExpenseCategoryResource = new ExpenseCategory();


export let ExpenseSchema = function(defaults = {}) {
    let schema = {
        reference: null,
        contact_id: null,
        team_id: null,
        tax_at: new Moment(),
        items: [],
        id: null,
        is_paid: false,
        is_credit: false,
        documents: []
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
}

export let ExpenseItemSchema = function(defaults = {}) {
    let schema = {
        expense_id: null,
        expense_category_id: null,
        instance_id: null,
        unit_cost: null,
        vat_rate: VatTariffs.STANDARD,
        quantity: 1,
        description: null,
        custom_total_vat: null,
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
}